// Retailers that no longer exist and must never render as buy options.
// Moosejaw shut down (folded into Public Lands), so its links are dead.
// Matched case-insensitively against the stored `retailer` key.
export const DEFUNCT_RETAILERS = new Set(["moosejaw"]);

const cleanProduct = (product) => {
  if (
    !product ||
    typeof product !== "object" ||
    !Array.isArray(product.retailers)
  ) {
    return product;
  }
  return {
    ...product,
    retailers: product.retailers.filter(
      (r) => r && !DEFUNCT_RETAILERS.has(String(r.retailer || "").toLowerCase())
    ),
  };
};

// Strip defunct retailers from any gear-API payload before it reaches the UI.
// Handles the three shapes the API returns: a single product, an array of
// products, and a deals object whose values are arrays of products
// (e.g. { tentDeals: [...], backpackDeals: [...] }).
export const stripDefunctRetailers = (data) => {
  if (Array.isArray(data)) return data.map(cleanProduct);
  if (data && typeof data === "object") {
    if (Array.isArray(data.retailers)) return cleanProduct(data);
    const out = { ...data };
    Object.keys(out).forEach((key) => {
      if (Array.isArray(out[key])) out[key] = out[key].map(cleanProduct);
    });
    return out;
  }
  return data;
};
